export enum OptionsListItemTypeEnum {
  Correct = 'CORRECT',
  Default = 'DEFAULT',
  Incorrect = 'INCORRECT',
  Missed = 'MISSED',
  Selected = 'SELECTED',
  Answered = 'ANSWERED',
  PartiallyCorrect = 'PARTIALLY_CORRECT',
  PartiallyCorrectMissed = 'PARTIALLY_CORRECT_MISSED',
}
